import { ReactNode } from 'react';
import { PermissionBoundary } from '../../../../core/permissions/permission-boundary.component';
import { NavigationItem } from './navigation-bar.component';
import { makeNavigationLeafPermissions } from './navigation-item.utils';

/** Shows a menu only when its own checks pass and at least one of its leaves would show. */
export function NavigationMenuBoundary({ item, children }: { item: NavigationItem; children: ReactNode }) {
  return (
    // First check if the permissions attached to the nav item pass (all need to pass)
    <PermissionBoundary permissions={item.permissions} availableUiFeatures={item.availableUiFeatures}>
      {/* Second check: the menu's leaves, see makeNavigationLeafPermissions */}
      <PermissionBoundary {...makeNavigationLeafPermissions(item.children)}>{children}</PermissionBoundary>
    </PermissionBoundary>
  );
}
